module.exports = __webpack_public_path__ + "img/block-4.c61c5cca.png";